import { call, select, takeLatest } from 'redux-saga/effects';
import { get, map } from 'lodash';
import { getVenuesProductionsAction, getVenuesWithProductionsAction } from './actions';
import { getListSaga, getWholeListSaga } from '../App/saga';
import { selectListData } from '../../store/selectors';
import { selectVenuesDomain } from './selectors';
import { initialState } from './reducer';
import { PRODUCTIONS } from '../../constants/endpointConstants';
import { dateSendFormat } from '../../utils/common';

export function* getVenuesWithProductionsSaga({ payload }) {
  yield call(getListSaga, { payload });
  const venues = yield select(selectListData(selectVenuesDomain, initialState.venues.listName));
  const ids = map(venues, venue => get(venue, 'id'));
  const productionsPayload = {
    endpoint: PRODUCTIONS,
    sagaRoutine: getVenuesProductionsAction,
    params: { queryParams: { date_from: dateSendFormat(), venue_id: ids.join(','),  approved_by: 'admin,company', } },
  };
  yield call(getWholeListSaga, { payload: productionsPayload });
}

export default function* venuesSaga() {
  yield takeLatest(getVenuesWithProductionsAction.TRIGGER, getVenuesWithProductionsSaga);
}
